/**
 * soj 相关处理
 */
import { isPlainObject } from './base';

/**
 *  拼接source_h5
 * @param  {[type]} client [description]
 * @return {[type]}        [description]
 */
export function getSourceH5(client) {
  const params = {
    app: 'unknown',
    os: 'unknown',
    ver: 'unknown',
    cate_id: '1',
  };

  if (!isPlainObject(client)) return { source_h5: params };
  const {
    source = 'unknown',
    system = 'unknown',
    version,
  } = client;
  params.app = source;
  params.os = system;
  params.ver = version;
  return { source_h5: params };
}

export function getScreen() {
  const sinfo = {};
  sinfo.w = (window.screen.width).toString();
  sinfo.h = (window.screen.height).toString();
  sinfo.r = (window.devicePixelRatio >= 2 ? 1 : 0).toString();
  return sinfo;
}

export function getAppName(type = 0) {
  let name = '';
  switch (type) {
    case 0:
      name = 'unknow';
      break;
    case 1:
      name = 'anjuke';
      break;
    case 2:
      name = 'wuba';
      break;
    case 3:
      name = '58tw';
      break;
    case 4:
      name = 'broker';
      break;
    case 5:
      name = 'jikejia';
      break;
    case 6:
      name = 'wechat';
      break;
    case 7:
      name = 'momo';
      break;
    case 21:
      name = 'ajkweapp';
      break;
    case 22:
      name = 'ajkbdweapp';
      break;
    case 23:
      name = '58weapp';
      break;
    case 24:
      name = 'tzweapp';
      break;
    case 25:
      name = '58xinfang';
      break;
    case 26:
      name = 'ajkxinfang';
      break;
    default:
      name = 'unknow';
      break;
  }
  return name;
}

export function getSite(type = 0) {
  let site = '';
  switch (type) {
    case 2:
    case 3:
    case 23:
    case 24:
    case 25:
      site = 'wuba';
      break;
    case 0:
    case 1:
    case 21:
    case 22:
    case 26:
      site = 'anjuke';
      break;
    default:
      site = 'anjuke';
      break;
  }
  return site;
}

export function getAppNameParams(type = 0) {
  let name = '';
  switch (type) {
    case 0:
      name = 'unknow';
      break;
    case 1:
      name = 'anjuke';
      break;
    case 2:
      name = 'wuba';
      break;
    case 3:
      name = '58tw';
      break;
    case 4:
      name = 'broker';
      break;
    case 5:
      name = 'jikejia';
      break;
    case 6:
      name = 'wechat';
      break;
    case 7:
      name = 'momo';
      break;
    case 21:
      name = 'ajk_weapp';
      break;
    case 22:
      name = 'ajk_bdweapp';
      break;
    case 23:
      name = '58_weapp';
      break;
    case 24:
      name = 'tz_weapp';
      break;
    case 25:
      name = '58_xinfang';
      break;
    case 26:
      name = 'ajk_xinfang';
      break;
    default:
      name = 'unknow';
      break;
  }
  return name;
}

export function getCp(appNameType, pageName, pm) {
  return {
    appname: getAppName(appNameType),
    app: getAppName(appNameType),
    pm,
    pageName,
  };
}

export function getAjkType(systemSoj) {
  let app = '';
  const s = systemSoj.toLocaleLowerCase();
  if (s === 'android') {
    app = 'a-ajk';
  } else if (s === 'ios') {
    app = 'a-ajk';
  } else {
    app = 'unknow';
  }
  return app;
}
